import * as React from 'react';

import './ToggleSwitch.css';

export interface ToggleSwitchProps {
  id: string;
  checked: boolean;
  name?: string;
  onChange: (id: string, value: boolean) => void;
}
export class ToggleSwitch extends React.Component<ToggleSwitchProps> {
  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    this.props.onChange(this.props.id, checked);
  };

  render() {
    return (
      <div className="switch">
        <input
          id={this.props.id}
          name={this.props.name}
          className="cmn-toggle cmn-toggle-round-flat"
          type="checkbox"
          checked={this.props.checked}
          onChange={this.handleChange}
        />
        <label htmlFor={this.props.id} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ToggleSwitch.tsx